var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-wrapper container" },
    [
      _c("pages-side-bar", { staticClass: "side-nav" }),
      _c("div", { staticClass: "content html-content" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }